import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  highlight?: string;
  after?: string;
  description?: string;
  tone?: 'light' | 'dark';
  align?: 'center' | 'left';
};
export function SectionHeading({
  eyebrow,
  title,
  highlight,
  after,
  description,
  tone = 'light',
  align = 'center'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  const accent = dark ? 'text-amber' : 'text-teal';
  return <div className={align === 'center' ? 'mx-auto mb-8 max-w-[780px] text-center md:mb-14' : 'mb-8'} data-id="element-182" data-mp="bl5bcozmrc6y">
      {eyebrow && <p className={`mb-3 text-xs font-bold uppercase tracking-[3px] ${dark ? 'text-teal-light' : 'text-teal-dark'}`} data-id="element-183" data-mp="glav7iznrueh">
          {eyebrow}
        </p>}
      <h2 className={`font-display text-[clamp(34px,5.2vw,60px)] font-extrabold uppercase leading-[0.95] ${dark ? 'text-white' : 'text-navy'}`} data-id="element-184" data-mp="6sc3vtcs1pr6">
        {title} {highlight && <span className={accent} data-id="element-185" data-mp="zbiutr45g2px">{highlight}</span>}
        {after && ` ${after}`}
      </h2>
      {description && <p className={`mt-5 text-base md:text-lg ${dark ? 'text-white/75' : 'text-muted'}`} data-id="element-186" data-mp="1t7uwzgz0fnld">{description}</p>}
    </div>;
}